import { db } from "../../index";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../App";
import {startLoading, stopLoading} from "../loader";

export async function createDriver(userInfos, driver) {
  startLoading();

  let snap = await db.ref(`users/${userInfos.uid}/driver`).push(driver);
  snap = await db
    .ref(`users/${userInfos.uid}/driver/${snap.key}`)
    .update({ id: snap.key });

  stopLoading();

  return snap;
}

export async function updateDriver(userInfos, driver) {
  startLoading();
  await db.ref(`users/${userInfos.uid}/driver/${driver.id}`).update(driver);
  stopLoading();
}

export async function deleteDriver(userInfos, driver_id) {
  if (!Array.isArray(driver_id)) {
    driver_id = [driver_id];
  }

  startLoading();

  let pList = driver_id.map(async (id) => {
    if (id) await db.ref(`users/${userInfos.uid}/driver/${id}`).remove();
  });

  await Promise.all(pList);

  stopLoading();
}

export function useDrivers() {
  const { userInfos } = useContext(UserContext);
  const [drivers, setDrivers] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    db.ref("users/" + userInfos.uid + "/driver")
      .once("value")
      .then((snapshot) => {
        let res = [];
        snapshot.forEach(function (childSnapshot) {
          res.push({
            id: childSnapshot.key,
            ...childSnapshot.val(),
          });
        });
        setDrivers(res);
        setLoaded(true);
      });
  }, [userInfos.uid]);

  return { drivers, loaded };
}
